import React, { FC, memo } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { IRootState } from 'store';
import { IDResource, IAnetaPackState } from 'types';
import { connect } from 'react-redux';
import Delete from 'style/imgs/icons/delete-icon.svg';
import DragIcon from './dragIcon';
import styles from '../index.module.scss';

const mstp = (state: IRootState) => ({
  anetaPack: state.anetaPack,
});
interface IhomeRoomListItemProps {
  idx: number;
  dndId: number;
  data: IDResource;
  errorLink?: IDResource;
  anetaPack?: IAnetaPackState;
  removeResourceFromSchedule?: (id: number) => void;
}
const HomeRoomListItem: FC<IhomeRoomListItemProps> = ({
  data,
  idx,
  dndId,
  removeResourceFromSchedule,
  errorLink,
  anetaPack,
}) => {
  const getEventColor = () => {
    let eventColor;
    if (dndId === 1) {
      eventColor = '#10C9BE';
    }
    anetaPack?.currentAnetaPack?.digitalResources?.forEach((el) => {
      if (el.id === data.id) {
        eventColor = '#168abc';
      }
    });
    if (errorLink?.id === data.id) {
      eventColor = '#e44575';
    }

    return eventColor;
  };

  return (
    <Draggable key={data.id} draggableId={`${data.id}`} index={idx}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <div
            className={styles.dResouceItem}
            style={{ background: getEventColor() }}
          >
            <div className={styles.backgroundHomeroom}>
              <span style={{ color: getEventColor() }} title={data.link}>
                {data.link}
              </span>
              {removeResourceFromSchedule && (
                <div
                  className={`${styles.deleteBlock} ${styles.deleteHomeroom}`}
                >
                  <button
                    type="button"
                    onClick={() => removeResourceFromSchedule(data.id)}
                    className={styles.trash}
                  >
                    <img src={Delete} alt="delete event" />
                  </button>
                </div>
              )}
            </div>
            <div className={styles.iconDrag}>
              <DragIcon color="#fff" width={16} height={16} />
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default memo(connect(mstp)(HomeRoomListItem));
